<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="7"
    y="5"
    width="2"
    height="2"
    rx="1"
    stroke="currentColor"
    stroke-width="2"
  />

  <rect
    x="1"
    y="1"
    width="14"
    height="14"
    rx="3"
    stroke="currentColor"
    stroke-width="2"
  />

  <path
    d="M3 15C3 12.2386 5.23858 10 8 10C10.7614 10 13 12.2386 13 15H3Z"
    fill="currentColor"
  />
</svg>
